import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { fmtDate } from "../api";
import { LockSimple, Camera } from "@phosphor-icons/react";
import { LegalLinks } from "../components/LegalLinks";

export default function PhotosLink() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/public/visit-photos/${token}`).then((r) => setData(r.data)).catch((e) => setErr(e.response?.data?.detail || "This photos link isn't valid"));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only load by design
  }, [token]);

  return (
    <div className="min-h-screen bg-background px-4 py-8" data-testid="photos-link-page">
      <div className="mx-auto w-full max-w-2xl space-y-4">
        {data?.logo_url && <img src={data.logo_url} alt="" className="mx-auto max-h-14" data-testid="photos-link-logo" />}
        <p className="text-center font-heading text-xl font-bold" data-testid="photos-link-business">{data?.business_name || "Visit photos"}</p>
        {err && (
          <div className="card-flat space-y-2 p-8 text-center" data-testid="photos-link-error">
            <LockSimple size={40} weight="bold" className="mx-auto text-muted-foreground" />
            <p className="font-heading text-lg font-bold">Link unavailable</p>
            <p className="text-sm text-muted-foreground">{err}</p>
          </div>
        )}
        {!err && !data && <p className="text-center text-muted-foreground">Loading…</p>}
        {data && (
          <>
            <div className="text-center">
              <p className="font-heading text-lg font-bold" data-testid="photos-link-property">{data.property_name}</p>
              <p className="text-sm text-muted-foreground" data-testid="photos-link-date">Completed {fmtDate(data.completed_at || data.date)}</p>
              {data.completion_notes && <p className="mt-1 text-sm italic text-muted-foreground" data-testid="photos-link-notes">{data.completion_notes}</p>}
            </div>
            {data.photo_count === 0 ? (
              <div className="card-flat space-y-2 p-8 text-center" data-testid="photos-link-empty">
                <Camera size={40} weight="bold" className="mx-auto text-muted-foreground" />
                <p className="text-sm text-muted-foreground">No photos on this visit.</p>
              </div>
            ) : (
              <div className="grid grid-cols-2 gap-2 sm:grid-cols-3" data-testid="photos-link-grid">
                {Array.from({ length: data.photo_count }, (_, i) => (
                  <img key={i} src={`${process.env.REACT_APP_BACKEND_URL}/api/public/visit-photos/${token}/${i}`}
                    alt={`Visit photo ${i + 1}`} data-testid={`photos-link-img-${i}`}
                    className="aspect-square w-full rounded-md object-cover" loading="lazy" />
                ))}
              </div>
            )}
          </>
        )}
        <p className="text-center text-xs text-muted-foreground">Sent by {data?.business_name || "your operator"} via RPM Field (Veloktify)</p>
        <LegalLinks />
      </div>
    </div>
  );
}
